/* eslint-disable */
import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';

import { observer } from 'mobx-react';
import { Px } from '../assets/posize';
import HeaderSkipWhite from './HeaderSkipWhite';
import Indexes from '../components/Indexes';

import '../assets/styles/class.scss';

@observer
export default class Answers extends React.Component {
  videoRef = React.createRef();

  handlerCanplay = () => {
    const video = this.videoRef.current;
    video.play();
  };

  handlerEnd = () => {
    this.props.videoEnd();
    this.isPlaying = false;
  };

  handlerClear = () => {
    this.isPlaying = false;
  };

  componentDidMount() {
    const { answers, index } = this.props;
    const answer = answers[index];
    const video = this.videoRef.current;

    video.src = answer.video;
    video.volume = 0.5;
    video.load();
  }

  componentWillUnmount() {
    const video = this.videoRef.current;
    video.pause();
  }

  render() {
    const { questions, answers, index, isMuted, setMuted } = this.props;
    const answer = answers[index];

    return (
      <div
        className={`answers position ${css(styles.group, styles.group_layout)}`}
      >
        <video
          muted={isMuted}
          onCanPlay={this.handlerCanplay}
          onEnded={this.handlerEnd}
          ref={this.videoRef}
          playsInline
          webkit-playsInline
        ></video>

        <div className={css(styles.flex, styles.flex_layout)}>
          <div className={css(styles.component, styles.component_layout)}>
            <HeaderSkipWhite
              isMuted={isMuted}
              setMuted={setMuted}
              handlerEnd={this.handlerEnd}
            />
          </div>

          <div className={css(styles.flex_spacer)} />

          <h1 className={css(styles.big_title, styles.big_title_layout)}>
            {answer.content}
          </h1>
          <div className={css(styles.flex_spacer1)} />

          <div className={css(styles.group1, styles.group1_layout)}>
            <div className={css(styles.component, styles.component_layout1)}>
              <Indexes questions={questions} index={index} />
            </div>
          </div>

          <div className={css(styles.flex_spacer2)} />
        </div>
      </div>
    );
  }
}

Answers.inStorybook = true;

const styles = StyleSheet.create({
  group: {
    display: 'flex',
    backgroundColor: 'rgba(255,255,255,0)'
  },
  group_layout: {
    position: 'absolute',
    flexGrow: 1,
    inset: 0
  },
  flex: {
    display: 'flex',
    flexDirection: 'column'
  },
  flex_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '49px 165px',
    '@media (max-width: 1199.98px)': {
      margin: '25px 83px'
    },
    '@media (max-width: 991.98px)': {
      margin: '25px 42px'
    },
    '@media (max-width: 767.98px)': {
      margin: '25px 21px'
    },
    '@media (max-width: 575.98px)': {
      margin: '25px 11px'
    }
  },
  component: {},
  component_layout: {
    margin: '5px 0px 0px',
    '@media (max-width: 991.98px)': {
      margin: '3px 0px 0px'
    },
    '@media (max-width: 767.98px)': {
      margin: '2px 0px 0px'
    },
    '@media (max-width: 575.98px)': {
      margin: '1px 0px 0px'
    }
  },
  flex_spacer: {
    flex: '1 1 402px'
  },
  big_title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '500 30px/1.73 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    textShadow: '0px 0px 8px rgba(0,0,0,0.5019607843137255)',
    letterSpacing: '0px',
    '@media (max-width: 991.98px)': {
      fontSize: '29px',
      textAlign: 'center'
    },
    '@media (max-width: 767.98px)': {
      fontSize: '22px'
    },
    '@media (max-width: 575.98px)': {
      fontSize: '16px'
    }
  },
  big_title_layout: {
    minHeight: 52,
    '@media (max-width: 991.98px)': {
      margin: 0
    }
  },
  flex_spacer1: {
    flex: '1 1 231px'
  },
  group1: {
    display: 'flex'
  },
  group1_layout: {
    position: 'relative',
    width: 490,
    minWidth: 490,
    margin: '0px auto',
    '@media (max-width: 575.98px)': {
      width: 350,
      minWidth: 350
    }
  },
  component_layout1: {
    flexGrow: 1,
    '@media (max-width: 991.98px)': {
      margin: '9px 0px 0px'
    },
    '@media (max-width: 767.98px)': {
      margin: '5px 0px 0px'
    },
    '@media (max-width: 575.98px)': {
      margin: '3px 0px 0px'
    }
  },
  flex_spacer2: {
    flex: '1 1 92px'
  }
});
